app.controller('OrganizationalUnitAddController', [
   '$scope', '$uibModalInstance', 'params', 'OrganizationalUnit',
   function ($scope, $uibModalInstance, params, OrganizationalUnit) {
     $scope.submit = function () {
       var unit = {name: $scope.name};



       if (params.parentId) {
         return OrganizationalUnit.createChild(params.parentId, unit).then(function(){
             $uibModalInstance.close();
         });
       }

       return OrganizationalUnit.createRoot(unit).then(function(){
           $uibModalInstance.close();
       });
     };

     $scope.close = function () {
       $uibModalInstance.dismiss();
     };
   }
 ])
